<template>
  <div class="grid">
    <div
      v-for="card in displayCards"
      :key="`${idPrefix}-${card.title}`"
      class="col-12 sm:col-6 lg:col-3"
    >
      <StatCard
        :title="card.title"
        :content-str="card.contentStr"
        :card-type="card.cardType"
        :sub-content-str="card.subContentStr"
        :loader="card.loader"
        :is-plus="card.isPlus"
      />
    </div>
    <div v-if="showEmptyState" class="col-12">
      <div class="md-empty">No data available.</div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from "vue";
import StatCard from "@/components/AdminNewDashboard/AdminNewDashboardComponents/StatCard.vue";

const PLACEHOLDER_COUNT = 4;

const props = defineProps({
  cards: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
  idPrefix: {
    type: String,
    default: "summary",
  },
  placeholderLabels: {
    type: Array,
    default: () => [],
  },
});

const displayCards = computed(() => {
  if (props.cards.length) {
    return props.cards.map((card, index) => ({
      title: card.title ?? `card-${index}`,
      contentStr: card.contentStr ?? card.value ?? "",
      cardType: card.cardType ?? card.type ?? "normal",
      subContentStr: card.subContentStr ?? card.delta ?? "",
      loader:
        props.loading && !props.cards.length ? 1 : (card.loader ?? 0),
      isPlus: card.isPlus ?? true,
    }));
  }
  if (props.loading) {
    const labels =
      props.placeholderLabels.length > 0
        ? props.placeholderLabels
        : Array.from(
            { length: PLACEHOLDER_COUNT },
            (_, index) => `metric-${index}`
          );
    return labels.map((label) => ({
      title: label,
      contentStr: "",
      cardType: "normal",
      subContentStr: "",
      loader: 1,
      isPlus: true,
    }));
  }
  return [];
});

const showEmptyState = computed(
  () => !props.loading && !props.cards.length && !displayCards.value.length
);
</script>

<style scoped>
.md-empty {
  border: 1px dashed var(--surface-border);
  border-radius: 12px;
  padding: 1.25rem;
  text-align: center;
  font-size: 0.9rem;
  color: var(--text-color-secondary);
  background: var(--surface-ground);
}
</style>
